import { render, staticRenderFns } from "./form-manager.vue?vue&type=template&id=fba23ff0&scoped=true"
import script from "./form-manager.vue?vue&type=script&lang=js"
export * from "./form-manager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fba23ff0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fba23ff0')) {
      api.createRecord('fba23ff0', component.options)
    } else {
      api.reload('fba23ff0', component.options)
    }
    module.hot.accept("./form-manager.vue?vue&type=template&id=fba23ff0&scoped=true", function () {
      api.rerender('fba23ff0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/flow/form/form-manager.vue"
export default component.exports